// extracted by mini-css-extract-plugin
export var option = "_a2-0";
export var optionCard = "_a2-f";
export var optionContent = "_a2-g";
export var optionIcon = "_a2-i";
export var optionIconBox = "_a2-h";
export var optionLabel = "_a2-j";
export var optionPill = "_a2-m";
export var optionPillBadge = "_a2-p";
export var optionPillIcon = "_a2-n";
export var optionPillLabel = "_a2-o";
export var optionRadio = "_a2-k";
export var optionRadioInner = "_a2-l";
export var optionReveal = "_a2-2";
export var optionRevealDelay0 = "_a2-3";
export var optionRevealDelay1 = "_a2-4";
export var optionRevealDelay10 = "_a2-d";
export var optionRevealDelay11 = "_a2-e";
export var optionRevealDelay2 = "_a2-5";
export var optionRevealDelay3 = "_a2-6";
export var optionRevealDelay4 = "_a2-7";
export var optionRevealDelay5 = "_a2-8";
export var optionRevealDelay6 = "_a2-9";
export var optionRevealDelay7 = "_a2-a";
export var optionRevealDelay8 = "_a2-b";
export var optionRevealDelay9 = "_a2-c";
export var optionSelected = "_a2-1";